import { Tracking } from "cookiesConsent/domain/tracking"
import { startDeferredSegment } from "cookiesConsent/infrastructure/segment/startDeferredSegment"

export class SegmentTracking implements Tracking {
  start = (): void => {
    startDeferredSegment()
  }
}
